import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const TOKEN_KEY = 'msal.' + environment.clientId + ".idtoken";
@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  private accessToken: any;
  constructor() { }

  public getToken(): string {
    if (sessionStorage.getItem(TOKEN_KEY) !== undefined && sessionStorage.getItem(TOKEN_KEY) != null) {
      this.accessToken = sessionStorage.getItem(TOKEN_KEY);
    }
    return this.accessToken;
  }
}
